Greenmile.Survey.Sidebar.EntityGrid = function (entity) {

    var gridActionsSelector = '#SurveyLinkForm div.questionContent div.gridActions.ui-widget-header';
    var gridContainerSelector = '#SurveyLinkForm .questionContent .content .gridContainer';
    var entityToActionGrid = entity;
    var customNamespace = 'SurveyQuestionEntity';
    var customNamespaceCache = 'SurveyQuestionEntityCached';

    App.Objects.SurveyQuestionEntity = {
        updateGrid: function () {
            App.Forms.SurveyQuestionEntity.filterBuilder.executeFilter();
        }
    };

    this.getGridOptions = function (layoutIndex) {

        var actions = ["CUSTOM_FILTERS", "CUSTOMIZE_COLUMNS"];
        var options = {
            entity: customNamespace,
            columnCheckBox: {
                show: true,
                options: {
                    checkOnClickRow: true
                }
            },
            columnEdit: {
                show: false
            },
            actions: actions,
            gridActionsSelector: gridActionsSelector,
            entityToActionGrid: entityToActionGrid,
            gridContainner: gridContainerSelector,
            headerMenu: {
                headerMenuEventClass: Monet.Grid.ActionsModules.MenuShowTotals
            },
            multiColumnSort: true,
            multiSelect: false,
            frozenColumn: Monet.Grid.getIndexFrozenColumn(layoutIndex)
        };

        return options;
    };

    this.getProjection = function () {
        var pageLayout        = App.Forms[customNamespace].layout.index,
            projectionBuilder = new Monet.Builder.Projection();

        if (pageLayout) {
            projectionBuilder.setLayout(pageLayout);
            projectionBuilder.parseLayout();
            projectionBuilder.setPagination(App.Forms[customNamespace].pagination);
        }

        return projectionBuilder.projection.toString();

    };

    this.createGrid = function (layoutIndex) {
        var columns,
            dataView,
            grid,
            options,
            customizeColumns;

        options = this.getGridOptions(layoutIndex);

        columns = Monet.Grid.getGridLayout(layoutIndex, customNamespace);
        dataView = new Monet.Grid.DataProvider(columns, null, customNamespace);

        var gridActionContainer = document.querySelector(gridActionsSelector);
        gridActionContainer.innerHTML = '';

        var storageFilterObj = JSON.parse(Monet.Session.sessionStorage.filters);
        delete storageFilterObj[Monet.Session.User.id].SurveyQuestionEntity;
        Monet.Session.sessionStorage.filters = JSON.stringify(storageFilterObj);

        App.Forms.SurveyQuestionEntity.filterBuilder = null;

        grid = new Monet.Grid.GenericGrid(gridContainerSelector, dataView, columns, options);

        App.Forms[customNamespace].table = grid;
        App.Forms[customNamespace].dataProvider = dataView;
        App.Forms[customNamespace].layout = { index: layoutIndex };
        App.Forms.SurveyQuestionEntity.filterBuilder.setIdScreen('Survey');

        App.Forms[customNamespace].pagination = {
            first: 0,
            max: 51,
            blocked: false,
            canIncrement: true
        };

        customizeColumns = App.Forms.SurveyQuestionEntity.actions.customizecolumns;
        customizeColumns.setScreenName(customNamespace);

        customizeColumns.setCustomSaveAction(function (fieldsToSave) {
            var entityFields = App.Forms.SurveyQuestionEntity.fields;
            var searchGridColumns = fieldsToSave.searchGridColumns;

            var updateGrid = function (grid) {
                var columns = [grid.getColumns()[0]];
                columns = columns.concat(Monet.Grid.getGridLayout(layoutIndex, customNamespace));
                grid.setColumns(columns);
                grid.render();
            };

            for (var i in searchGridColumns) {
                for (var j in entityFields) {
                    if (entityFields[j].id === searchGridColumns[i].field.id) {
                        searchGridColumns[i].field = entityFields[j];
                        break;
                    }
                }
            }
            var layoutIndexSection = layoutIndex.sections.filter(function (item) {
                return item.sectionRelatedLists.length > 0;
            });

            layoutIndexSection[0].sectionRelatedLists[0].searchGridLayout.searchGridColumns = searchGridColumns;

            updateGrid(App.Forms[customNamespace].table);

            if (App.Forms[customNamespaceCache]) {
                updateGrid(App.Forms[customNamespaceCache].table);
            }

            var customizeColumns = document.querySelector('#EntityQuestion div.MonetUIGridActions > div.MonetUIGridActionsColumns.right');
            customizeColumns.style.display = 'none';

            App.Forms.SurveyQuestionEntity.filterBuilder.setProjection(this.getProjection());

            App.Forms.SurveyQuestionEntity.filterBuilder.executeFilter();

        }.bind(this));

        App.Forms.SurveyQuestionEntity.filterBuilder.setCallbacks({
            success: function (data) {
                var addPaginationGrid = true,
                    tableLayout       = Monet.Grid.getGridLayout(layoutIndex),
                    pagination        = App.Forms[customNamespace].pagination;

                if (pagination.first === 0) {

                    Monet.Grid.addDataToGrid(customNamespace, tableLayout, data, addPaginationGrid);

                } else {

                    Monet.Grid.appendDataToGridAfterPagination(customNamespace, tableLayout, data);

                }
            }
        });

        App.Forms.SurveyQuestionEntity.filterBuilder.executeFilter();
    };

};